/**
 * Copyright Highway9 Networks Inc.
 */
import type { PermissionsMap } from "~/types/rbac";
import type { Permission } from "~/types/user";

/** Normalize API permission list into the Redux permissions map shape. */
export function permissionsMapFromApi(permissions: Permission[] | null | undefined): PermissionsMap {
  const permissionsMap: PermissionsMap = {};
  permissions?.forEach((permission) => {
    if (!permissionsMap[permission.objectType]) {
      permissionsMap[permission.objectType] = {};
    }
    permission.permissions.forEach((permissionType) => {
      const entry = permissionsMap[permission.objectType];
      if (entry) {
        entry[permissionType] = true;
      }
    });
  });
  return permissionsMap;
}
